import { render, staticRenderFns } from "./employee-list.vue?vue&type=template&id=23297bee&"
import script from "./employee-list.vue?vue&type=script&lang=js&"
export * from "./employee-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports